import { API } from 'aws-amplify';
import { listStandardDocuments } from '../../../../graphql/queries';
import { setList } from './standardDocumentsSlice';
import store from '../../../../app/store';

export const getItems = async () => {
    try {
        let items = [];
        let token;
        do {
            const response = await API.graphql({
                query: listStandardDocuments,
                variables: { limit: 2000, nextToken: token },
            });
            items = [...items, ...(response.data?.listStandardDocuments?.items || [])];
            token = response.data?.listStandardDocuments?.nextToken;
        } while (token);
        store.dispatch(setList(items));
    } catch (e) {
        console.log(e);
    }
};